import HRTournamentModel from './hr-tournament-model';

/**
 * Sport model
 */
export default class HorseRacingModel {
  constructor(data) {
    /**
     * Horse race id
     * @type {number}
     */
    this.id = data.id;
    /**
     * Flag is horse race 3way
     * @type {boolean}
     */
    this.is3way = data.is3way;
    /**
     * Horse race name
     * @type {string}
     */
    this.name = data.n;
    /**
     * Horse race tournaments
     * @type {HRTournamentModel[]}
     */
    this.tabs = data.t ? data.t.map(t => new HRTournamentModel({
      ...t,
      sid: this.id,
    })) : [];
  }
}
